/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Private_Models_Fact_ReasoningInputs */



/**
* | output |
* | --- |
* | "Reasoning arrives in the field {field}" |
*
* @param {Private_Models_Fact_ReasoningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_fact_reasoning = /** @type {((inputs: Private_Models_Fact_ReasoningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Fact_ReasoningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Reasoning kommt im Feld ${i?.field}`)
	return /** @type {LocalizedString} */ (`Reasoning arrives in the field ${i?.field}`)
});